module.exports = __webpack_public_path__ + "static/media/bg-lhtv.b971401a.png";